module.exports = "<div class=\"q-marg-top-sm sku-inactive-error\"> <div class=\"q-alert q-alert-red\"> <span class=q-boldest>This SKU is inactive.</span> Please remove this SKU to continue editing. </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/skuInactive.html
// module id = 1370
// module chunks = 1